import { apiUrl } from "./config";

async function request(path, payload, { authToken, signal, download = false }) {
  if (!authToken) return { success: false, error: "請先登入。", status: 401 };
  try {
    const response = await fetch(`${apiUrl}/ai/short-answers/${path}/`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken}` },
      body: JSON.stringify(payload),
      signal,
    });
    if (response.ok && download) return { success: true, blob: await response.blob() };
    const result = await response.json().catch(() => ({}));
    if (response.ok && result.success) return result;
    const fieldError = Object.values(result).find((value) => Array.isArray(value));
    return {
      success: false,
      error: result.error || result.detail || (fieldError && fieldError.join("、")) || "簡答處理失敗，請檢查輸入後重試。",
      code: result.code,
      status: response.status,
    };
  } catch (error) {
    if (error.name === "AbortError") return { success: false, cancelled: true };
    return { success: false, error: "無法連線至簡答服務，已完成的答案會保留。", status: 0 };
  }
}

export const splitShortAnswerQuestions = ({ text, ...options }) => request("split", { text }, options);
export const generateShortAnswer = ({ question, context, ...options }) => request("generate", { question, context }, options);
export const exportShortAnswers = ({ title, filename, rows, confirmed, schoolLevel, ...options }) =>
  request("export", {
    title, filename, rows, confirmed,
    ...(schoolLevel ? { school_level: schoolLevel } : {}),
  }, { ...options, download: true });
